import { CARD_IMAGE_MAP } from "../generated/cardImageManifest";

/**
 * Prefer a card-sized WebP sibling when the optimize script has generated one.
 * Falls back to the original path so missing assets never 404.
 */
export function toCardImage(src: string | undefined | null): string {
  if (!src) return "";
  return CARD_IMAGE_MAP[src] ?? src;
}

/** Map a list of gallery/cover URLs through the card manifest. */
export function toCardImages(sources: string[]): string[] {
  return sources.map((src) => toCardImage(src)).filter(Boolean);
}
